import React, { Suspense } from 'react';

import { Spinner } from "react-bootstrap";

import FechGetClubLongDescBySlug from "../fechData/FechGetClubLongDescBySlug";
import BeltClub from '../components/BeltClub';

const ClubReservationOnlinePage = React.lazy(() => import('../pageDefault/ClubReservationOnlinePage'));

class ClubReservationPage extends React.Component {

  constructor(props) {
    super(props);
  }

  state = {
    currentPage: "1",
    restClubData: {
      successful: false,
      status: '',
      message: '',
      data: []
    }
  }


  async componentDidMount() {
    
    this.setState({
      restClubData: await FechGetClubLongDescBySlug(this.props.match.params.slug)
    });
    var sport = 0;
        if (this.state.restClubData.successful && this.state.restClubData.data != undefined) {
          if(this.props.match.params.page == 1) {
            sport = this.state.restClubData.data.reservationPage1Sport
          }
          if(this.props.match.params.page == 2) {
            sport = this.state.restClubData.data.reservationPage2Sport
          }
          if(this.props.match.params.page == 3) {
            sport = this.state.restClubData.data.reservationPage3Sport
          }
        }
    
        var sportDesc = "Tenis";
        if(sport == 1) sportDesc = "Squash";
        if(sport == 2) sportDesc = "Padel";
        const fallbackDate = new Date().toISOString().slice(0, 10);
        const dateReservationDesc = this.props.match?.params?.date ?? fallbackDate;

        const title = this.state.restClubData.data.name + " Rezerwacja kortów " + sportDesc + " " + dateReservationDesc + " - RezerwujKort.pl";
        document.title = title;

        // if (window._paq) {
        //   window._paq.push(['setDocumentTitle', title]);
        // }
        if (window._paq) {
          window._paq.push(["setDocumentTitle", title]);
          window._paq.push([
            "setCustomUrl",
            window.location.pathname + window.location.search,
          ]);
          window._paq.push(["trackPageView"]);
        }
  }

  render() {

    var returnValue = '';
    var beltClub;
    if (this.state.restClubData.successful) {

      var cur = "reservation" + (this.props.match.params.page)
      beltClub = <BeltClub
        dataClubInfo={this.state.restClubData.data}
        dateReservation={this.props.match.params.date}
        currentPage={cur}
      />

      returnValue = <div>
        <Suspense fallback={<div>
          <Spinner style={{ 'borderStyle': 'dotted', 'marginLeft': '50%' }} animation="border" />
        </div>}>
          <ClubReservationOnlinePage
            date={this.props.match.params.date}
            page={this.props.match.params.page}
            restClubData={this.state.restClubData}
            beltClub={beltClub}
            slug={this.props.match.params.slug} />
        </Suspense>
      </div>;
    }

    return (
      <>
        {returnValue}
      </>
    );
  }
}

export default ClubReservationPage;
